import { createBrowserRouter } from 'react-router';

import { Layout } from './pages/Layout';
import {
  AuthCallbackRoute,
  DungeonsRoute,
  InventoryRoute,
  MonitorRoute,
  NotFoundRoute,
  RouteSuspense,
  SettingsRoute,
  SpectatorRoute,
  TownRoute,
} from './routes.lazy';

/**
 * Browser router with all four primary routes nested under the shared
 * `Layout`, plus a `path: '*'` NotFound catch-all that also lives under
 * Layout so the NavBar stays visible on unknown URLs.
 *
 * `errorElement` is intentionally NOT configured here — route-level
 * error boundaries become relevant when loaders/actions land in Step 7+.
 *
 * Phase 3 Step 6 (2/4).
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: (
          <RouteSuspense>
            <SpectatorRoute />
          </RouteSuspense>
        ),
      },
      {
        path: 'town',
        element: (
          <RouteSuspense>
            <TownRoute />
          </RouteSuspense>
        ),
      },
      {
        path: 'inventory',
        element: (
          <RouteSuspense>
            <InventoryRoute />
          </RouteSuspense>
        ),
      },
      {
        path: 'dungeons',
        element: (
          <RouteSuspense>
            <DungeonsRoute />
          </RouteSuspense>
        ),
      },
      {
        path: 'settings',
        element: (
          <RouteSuspense>
            <SettingsRoute />
          </RouteSuspense>
        ),
      },
      {
        // OAuth callback leg (P6-5): the IdP redirects here; the page posts
        // the code/state back to the API and returns to Settings.
        path: 'auth/callback/:provider',
        element: (
          <RouteSuspense>
            <AuthCallbackRoute />
          </RouteSuspense>
        ),
      },
      {
        // Dev-only persona monitor (ADR 0038 §2.5); the page renders NotFound
        // in production builds.
        path: 'monitor',
        element: (
          <RouteSuspense>
            <MonitorRoute />
          </RouteSuspense>
        ),
      },
      {
        path: '*',
        element: (
          <RouteSuspense>
            <NotFoundRoute />
          </RouteSuspense>
        ),
      },
    ],
  },
]);
